import {Mutation} from './mutation-types'
import {showWarning} from "../utils";
export default {
    [Mutation.CREATE_ACTIVE_MACHINE] (state, activeMachine) {
        return state.activeMachines.push(activeMachine)
    },
    [Mutation.UPDATE_ACTIVE_MACHINE] (state, activeMachine) {
        if(!activeMachine)
            return showWarning('Maquina activa invalida, imposible actualizar')
        let activeMachineToUpdate = state.activeMachines.find(m => m.id  == activeMachine.id )
        if(!activeMachineToUpdate)
            return showWarning(`Maquina activa no existente (id ${activeMachine.id})`)
        let index = state.activeMachines.findIndex(m => m.id == activeMachine.id);

        if(activeMachineToUpdate.hasOwnProperty('error')) delete activeMachineToUpdate.error;
        state.activeMachines.splice(index, 1, {
            ...activeMachineToUpdate,
            ...activeMachine
        })
        return state.activeMachines;
    },
    [Mutation.DELETE_ACTIVE_MACHINE] (state, activeMachineId) {
        const index = state.activeMachines.findIndex(e => e.id == activeMachineId);
        if (index === -1)
            return showWarning(`Imposible eliminar equipo monitorizado (id ${activeMachineId})`)
        return state.activeMachines.splice(index, 1)
    },

    [Mutation.CREATE_PRODUCTION_LINE_COLLAPSE_STATE] (state, collapseState) {
        return state.productionLinesCollapseStates.push(collapseState)
    },
    [Mutation.CHANGE_COLLAPSABLE_PRODUCTION_LINE_STATE] (state, productionLineId) {
        var productionLineIndex = state.productionLinesCollapseStates.findIndex(l => l.id == productionLineId)
        //Cambia el estado de la linea seleccionada
        state.productionLinesCollapseStates[productionLineIndex].state = !state.productionLinesCollapseStates[productionLineIndex].state;
        //Cierra todas las lineas que no sean la directamente afectada
        state.productionLinesCollapseStates
            .filter(l => l.id != productionLineId)
            .forEach(function(productionLine, i){
                productionLine.state = false;
            })
        return state.productionLinesCollapseStates;
    }
}
